import assign from 'lodash/assign';
import constants from '../constants';

const initState = () => {
    return {
        min: null,
        max: null,
        items: []
    };
};

const comparables = (state = initState(), action = {}) => {
    const { type, payload } = action;

    if (type === constants.SET_COMPARABLES) {
        return assign({}, payload);
    }
    return state;
};

export default comparables;
